"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorScreen = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./ErrorScreen.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ErrorScreen = props => {
  const {
    onClose,
    onRetry
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: style['error-screen']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: style['image']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['content-block']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A"), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0438\xA0\u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451\xA0\u0440\u0430\u0437")), /*#__PURE__*/React.createElement("div", {
    className: style['content-block']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.Button, {
    onClick: onRetry,
    size: "M",
    fullWidth: false
  }, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C")), /*#__PURE__*/React.createElement("div", {
    className: style['action-link']
  }, /*#__PURE__*/React.createElement(_uiKit.ActionLink, {
    onClick: onClose,
    fontWeight: "bold",
    color: "current_color",
    spacingSize: "M"
  }, "\u041D\u0430\u0437\u0430\u0434 \u043A\xA0\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044E"))))));
};
exports.ErrorScreen = ErrorScreen;